import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsService {
    private appInsights: ApplicationInsights;
    private subs = new Subscription();

    constructor(private router: Router) {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.APPLICATIONINSIGHTS_InstrumentationKey,
                enableAutoRouteTracking: true,
            }
        });
        this.appInsights.loadAppInsights();
    }

    trackPageView(name?: string, uri?: string) {
        this.appInsights.trackPageView({ name, uri });
    }
    trackEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights.trackEvent({ name }, properties);
    }

    trackException(exception: Error, properties?: { [key: string]: any }) {
        this.appInsights.trackException({ exception, properties });
    }

    trackNavigationEvents() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.trackPageView(event.urlAfterRedirects, event.urlAfterRedirects);
        });
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
}